//CRN_20260508 - Riskline Country Reports service (PUSH side - reads from SureSim backend)
//CRN_20260513 - https://riskline.readme.io/reference/apis-overview

import { catchError, Observable, of, throwError } from 'rxjs';
import { CountryReportDTO } from '../../models/system/riskline/riskline-country-report.dto';
import { eSimApiPaths } from '../../consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../utelize/general/exceptions-service';
import { HttpClientService } from '../utelize/general/http-client-service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RisklineCountryReportsService {

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getCountryReport(isoCode: string, language?: string): Observable<CountryReportDTO> {
    try {
      if (!isoCode || isoCode.trim()=='')
        throw new Error('RisklineCountryReportsService.getCountryReport() - isoCode is required');

      const qs=(language && language.trim()!='') ? ('?language=' + encodeURIComponent(language)) : '';

      return this.httpClientService
             .get<CountryReportDTO>(environment.eSimApi +
                                    eSimApiPaths.RiskIntelligence + '/' +
                                    eSimApiPaths.RiskIntelligenceCountryReports + '/' +
                                    isoCode +
                                    qs)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklineCountryReportsService.getCountryReport() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
